// checked classes when element active
function initCheckedClasses() {
	var checkedClass = 'input-checked', parentCheckedClass = 'input-checked-parent';
	var pairs = [];
	jQuery('label[for]').each(function(index, label) {
		var input = jQuery('#'+label.htmlFor);
		label = jQuery(label);

		// click handler
		if(input.length) {
			pairs.push({input:input,label:label});
			input.click(function() {
				if(input.is(':radio')) {
					jQuery.each(pairs, function(index, pair) {
						refreshState(pair.input, pair.label);
					});
				} else {
					refreshState(input, label);
				}
			});
			refreshState(input, label);
		}
	});

	// refresh classes
	function refreshState(input, label) {
		if(input.is(':checked')) {
			input.parent().addClass(parentCheckedClass);
			label.addClass(checkedClass);
		} else {
			input.parent().removeClass(parentCheckedClass);
			label.removeClass(checkedClass);
		}
	}
}